import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import {
  selectSessionUserId,
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchRecommendedEpisodesQuery,
} from '@/store';

import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

export const RecommendedEpisodesCarousel = () => {
  const compliance = useSelector(selectUserCompliance);
  const audienceRegions = useSelector(selectUserAudienceRegions);
  const userId = useSelector(selectSessionUserId);

  const { data: episodes, isLoading } = useFetchRecommendedEpisodesQuery(
    {
      compliance,
      audienceRegions,
    },
    { skip: !userId },
  );

  return (
    <>
      {episodes && episodes?.length > 0 && (
        <EpisodeCardCarousel
          title="Recommended for You"
          uKey="Recommended for You"
          episodes={episodes}
          isLoading={isLoading}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.DISCOVER,
          }}
          sortCompletedEpisodesLast={true}
        />
      )}
    </>
  );
};
